document.addEventListener("DOMContentLoaded", function () {
	let prevScrollPos = window.scrollY;
	let scrollCutoffPos = window.scrollY;

	const mobileHeader = document.querySelector(
		".wp-block-template-part-header-bottom",
	);

	if (!mobileHeader) {
		return;
	}

	window.addEventListener("scroll", function () {
		const currentScrollPos = window.scrollY;

		if (mobileHeader.matches(":hover")) {
			scrollCutoffPos = currentScrollPos;
			mobileHeader.classList.remove("hide");

			return;
		}

		const isScrollDown = prevScrollPos < currentScrollPos;

		if (scrollCutoffPos - 50 > currentScrollPos || currentScrollPos < 50) {
			// user has scrolled up

			mobileHeader.classList.remove("hide");

			scrollCutoffPos = currentScrollPos;
		} else if (scrollCutoffPos + 20 < currentScrollPos && isScrollDown) {
			// user has scrolled down

			mobileHeader.classList.add("hide");

			scrollCutoffPos = currentScrollPos;
		}

		prevScrollPos = currentScrollPos;
	});
});
